import { Action, ErrorCodes, OperationType, Position, WindowType } from "puzzle";

export const reopenDeliverPing: Action = [{
  condition: '{reopenRequestData} && {reopenRequestData.processingFinished}',
  conditionOperations: [{
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'removeReopenInProcess',
    type: OperationType.action
  }, {
    data: {
      template: {
        notification: {
          bind: {
            id: '{processId}'
          }
        }
      }
    },
    moduleName: 'ToastNotifications',
    moduleId: 'ToastNotificationsViewport',
    name: 'addReopenFinishedNotifications',
    args: ['notification', 'reopenRequestData']
  }, {
    condition: '{activeDialog} === "ReopenDialog"',
    conditionOperations: [{
      moduleName: 'ReopenDialog',
      name: 'resetProcessingAfterDeliverViaWS',
      args: ['reopenRequestData']
    }],
    type: OperationType.conditional
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'removeReopenDispatcher',
    type: OperationType.action
  }],
  elseOperations: [{
    actionType: {
      delay: 1200
    },
    name: 'reopenUUIDRequest',
    type: OperationType.stack
  }],
  type: OperationType.conditional
}];

export const reopenUUIDRequest = [{
  data: {
    template: {
      method: 'post',
      headers: {
        bind: {
          'X-Process-Uuid': '{processId}'
        }
      },
      bind: {
        url: "'/submissions/' + {submissionId} + '/deliverViaWebServices'",
        params: '{params}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'reopenRequestData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{reopenRequestData}',
      }
    }
  },
  name: 'handleDeliverExceptionReopen',
  type: OperationType.action
}, {
  name: 'reopenDeliverPing',
  type: OperationType.action
}];

export const reopenDeliverRequest: Action = [{
  data: {
    template: {
      method: 'post',
      bind: {
        url: "'/submissions/' + {submissionId} + '/deliverViaWebServices'",
        params: '{params}'
      }
    }
  },
  handleErrorStatuses: [
    ErrorCodes.BAD_REQUEST,
    ErrorCodes.FORBIDDEN,
    ErrorCodes.INTERNAL_SERVER_ERROR,
    ErrorCodes.NOT_FOUND
  ],
  mappingName: 'reopenRequestData',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{reopenRequestData}',
      }
    }
  },
  name: 'handleDeliverExceptionReopen',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        processId: '{reopenRequestData.processId}',
      }
    }
  },
  type: OperationType.data
}, {
  moduleName: 'ToastNotifications',
  moduleId: 'ToastNotificationsViewport',
  name: 'setReopenProcessingNotification',
  args: ['processId']
}];

export const reopenDeliver: Action = [{
  actionType: {
    dispatcherId: 'mainDispatcher'
  },
  name: 'addReopenInProcess',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        processingTargets: '{params.targetIds}'
      }
    }
  },
  moduleName: 'ReopenDialog',
  name: 'setProcessingTargets',
  args: ['processingTargets', 'reopenInProcess']
}, {
  name: 'reopenDeliverRequest',
  type: OperationType.action
}, {
  name: 'reopenDeliverPing',
  type: OperationType.action
}];

/**
 * Handles error's on deliverViaWS endpoint
 */
export const handleDeliverExceptionReopen: Action = [{
  condition: '_.get({responseData}, "response.data.errors")}',
  conditionOperations: [{
    data: {
      template: {
        endpointPrefix: 'REOPEN_DELIVER_'
      }
    },
    type: OperationType.data
  }, {
    data: {
      template: {
        bind: {
          responseData: '{responseData.response}'
        }
      }
    },
    moduleName: 'ErrorHandler',
    name: 'prepareErrorStrings',
    args: ['responseData', 'endpointPrefix'],
    mappingName: 'errorStrings',
    type: OperationType.addOperationData
  }, {
    placeholders: {
      template: {
        bind: {
          close: '{errorStrings.close}',
          text: '{errorStrings.text}',
          title: '{errorStrings.title}',
          warningType: '{errorStrings.warningType}'
        }
      }
    },
    items: [{
      operations: [{
        name: 'closeAndUnlink',
        type: OperationType.action
      }],
      close: false,
      btnName: 'errorHandler.close',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      btnName: 'ESCAPE',
      close: false,
      operations: [{
        name: 'closeAndUnlink',
        type: OperationType.action
      }]
    }],
    className: '{warningType}',
    text: 'errorHandler.text',
    title: 'errorHandler.title',
    type: OperationType.warning
  }, {
    moduleName: 'App',
    type: OperationType.unmaskModule
  }, {
    moduleName: 'ReopenDialog',
    name: 'resetProcessingAfterDeliverViaWS',
    args: ['responseData']
  }, {
    data: {
      template: {
        notification: {
          bind: {
            id: '{processId}'
          }
        }
      }
    },
    moduleName: 'ToastNotifications',
    moduleId: 'ToastNotificationsViewport',
    name: 'removeNotificationFromList',
    args: ['notification']
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'removeReopenInProcess',
    type: OperationType.action
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'removeReopenDispatcher',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const removeReopenDispatcher: Action = [{
  dispatcherIds: ['reopenDispatcher'],
  type: OperationType.stopAll
}, {
  dispatcherIds: ['reopenDispatcher'],
  type: OperationType.unlink
}];

export const closeAndUnlink = [{
  windowType: WindowType.warning,
  type: OperationType.closeWindow
}, {
  dispatcherIds: ['reopenDispatcher'],
  type: OperationType.unlink
}];

export const addReopenInProcess = [{
  data: {
    template: {
      reopenInProcess: true,
    }
  },
  persistent: ['reopenInProcess'],
  type: OperationType.addPersistentData
}];

export const removeReopenInProcess = [{
  persistent: ['reopenInProcess'],
  type: OperationType.removePersistentData
}];